// Aktuelle fraud0-Theme-Klassen für Portale (createPortal → body erben das Theme nicht).
// Dark → nur 'fraud0-area' (neutrales Schwarz), sonst zusätzlich 'fraud0-light' (Weiss).
export function fraud0ThemeClass(): string {
  const dark = typeof localStorage !== 'undefined' && localStorage.getItem('fraud0Theme') === 'dark';
  return dark ? 'fraud0-area' : 'fraud0-area fraud0-light';
}
